"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _solarReact = require("@solar/solar-react");

var _HourglassEmpty = _interopRequireDefault(require("@material-ui/icons/HourglassEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TodoMessage = function TodoMessage(_ref) {
  var message = _ref.message,
      Icon = _ref.Icon;
  return /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
    Icon: Icon,
    label: message
  });
};

TodoMessage.propTypes = {
  Icon: _propTypes["default"].node,
  message: _propTypes["default"].string
};
TodoMessage.defaultProps = {
  Icon: _HourglassEmpty["default"],
  message: 'Work in progress'
};
var _default = TodoMessage;
exports["default"] = _default;